<template>
  <div id="app" class="container">
    <div class="row justify-content-md-center">
      <div class="col-md-6">
        <router-view :key="$route.path"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

.section-block {
  background-color: white;
  margin-top: 1em;
  margin-bottom: 0em;
  padding: 1em;
  text-align: center;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  font-size: 1.5em;
}

.nextgame {
  border-width: thick;
  border-style: solid;
  border-radius: 10%;
}
</style>
